import React from "react";

export const ContactUs = () => {
  return (
    <section>
      <div className="bg-[#fafad5] container">
        <div className="wrapper-text">
          <h2 className="text-2xl font-bold sm:text-4xl text-left ">
            Contact Us
          </h2>
          <br />
          <p>Bhavan’s Campus, Munshi Nagar, Andheri (West), Mumbai 400 058</p>
          <br />
          <p>ailab@spit.ac.in</p>
        </div>
        <div className="wrapper-image py-4 px-1 col-start-2 md:col-start-1">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3769.6459336030093!2d72.83392671439685!3d19.123182655458244!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7c9d90e067ba9%3A0x16268e5d6bca2e6a!2sBharatiya%20Vidya%20Bhavan&#39;s%20Sardar%20Patel%20Institute%20of%20Technology%20(SPIT)!5e0!3m2!1sen!2sin!4v1673198481226!5m2!1sen!2sin"
            alt="map-image"
            width="600"
            height="450"
            allowfullscreen=""
            referrerpolicy="no-referrer-when-downgrade"
            className="object-cover hover:object-scale-down"
            border="0"
          />
        </div>
      </div>
    </section>
  );
};